export default "__VITE_ASSET__D4Q4a84b__"